import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
})
export class ModalComponent {
  @Input() show: boolean = false;
  @Input() title: string = '';
  @Input() message: string = '';
  /** Label of the main button; defaults to "See my results". */
  @Input() primaryLabel: string = '';
  /** Optional second button, emitted through (secondary). */
  @Input() secondaryLabel: string = '';
  @Input() tone: 'success' | 'danger' | 'warning' | 'neutral' = 'neutral';
  /** Whether Escape / clicking the backdrop triggers (dismiss). */
  @Input() dismissible: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() secondary = new EventEmitter<void>();
  @Output() dismiss = new EventEmitter<void>();

  /** Move keyboard focus into the dialog as soon as it opens. */
  @ViewChild('primaryButton') set primaryButton(button: ElementRef<HTMLButtonElement> | undefined) {
    button?.nativeElement.focus();
  }

  get icon() {
    switch (this.tone) {
      case 'success':
        return 'fa-check-circle';
      case 'danger':
        return 'fa-times-circle';
      case 'warning':
        return 'fa-exclamation-circle';
      default:
        return '';
    }
  }

  onClose() {
    this.close.emit();
  }

  onSecondary() {
    this.secondary.emit();
  }

  onBackdrop(event: MouseEvent) {
    if (this.dismissible && event.target === event.currentTarget) {
      this.dismiss.emit();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    if (this.show && this.dismissible) {
      this.dismiss.emit();
    }
  }
}
